import React from 'react';
import { useSearchParams } from 'react-router-dom';
import RecordPurchase from './RecordPurchase';
import { PurchaseLogContent } from './PurchaseLog';
import IncomingInvoices from './IncomingInvoices';

export default function PurchaseHub() {
  const [params] = useSearchParams();
  const view = params.get('view');

  return (
    <div className="h-full min-h-0">
      {view === 'history'  ? <PurchaseLogContent /> :
       view === 'incoming' ? <IncomingInvoices />   :
                             <RecordPurchase />}
    </div>
  );
}
